import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { environment } from "../environments/environment";
import { GroupSelectedGuard } from "./shared/guards/group-selected-guard.service";
import { AuthGuard } from "./shared/guards/auth-guard.service";
import { SetThemeResolverService } from "./shared/guards/set-theme-resolver.service";
import { PublicAccessGuard } from "./shared/guards/public-access.guard";
import { ENV_BUILD } from "../environments/environment.dev";
import { ExceedersGuard } from "./shared/guards/exceeders.guard";
import { ProfileCompletedGuard } from "./shared/guards/profile-completed-guard.service";
import { TabsResolver } from "./shared/resolvers/tabs-resolver";
import { MembershipBlockedGuard } from "./shared/guards/membership-blocked-guard.service";
import { GroupAccessGuard } from "./shared/guards/group-access-guard";
import { PlannexeAddonResolver } from "@plannexe/shared/services/plannexe.resolvers.service";

const routes: Routes = [
  {
    path: "c/:id",
    loadComponent: () => import('./shared/components/shared-card/shared-card.component').then(c => c.SharedCardComponent),
  },
  {
    path: "smartcontract",
    loadComponent: () => import('./shared/components/smart-contact-card/smart-contact-card.component').then(c => c.SmartContactCardComponent),
  },
  {
    path: "pages",
    loadChildren: () =>
      import("./layout/pages-layout.module").then((m) => m.PagesLayoutModule),
    resolve: {
      theme: SetThemeResolverService,
      tabs: TabsResolver
    },
    canActivate: [
      GroupSelectedGuard,
      PublicAccessGuard,
      ProfileCompletedGuard,
      MembershipBlockedGuard,
      GroupAccessGuard,
    ],
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./auth/auth.module").then((module) => module.AuthModule),
    resolve: {
      theme: SetThemeResolverService,
    },
  },
    {
    path: 'file',
    loadChildren: () => import('./plannexe/file/file.module').then(r => r.FileModule),
    resolve: {
      addon: PlannexeAddonResolver
    },
  },
  {
    path: 'pdfs',
    loadChildren: () => import('./plannexe/pdfs/pdfs.module').then(r => r.PDFsModule),
    resolve: {
      addon: PlannexeAddonResolver
    },
  },
  {
    path: "news-item",
    loadChildren: () =>
      import("./separate-news-item/separate-news-item.module").then(
        (module) => module.SeparateNewsItemModule
      ),
    resolve: {
      theme: SetThemeResolverService,
    },
  },
  {
    path: "news",
    loadChildren: () =>
      import("./separate-news-page/separate-news.module").then(
        (module) => module.SeparateNewsModule
      ),
    canActivate: [GroupSelectedGuard],
    resolve: {
      theme: SetThemeResolverService,
    },
  },
  {
    path: "groups",
    loadChildren: () =>
      import("./groups/groups.module").then((module) => module.GroupsModule),
    canActivate: [AuthGuard],
    resolve: {
      theme: SetThemeResolverService,
    },
  },
  {
    path: "products",
    loadChildren: () =>
      import("./products/products.module").then(
        (module) => module.ProductsModule
      ),
    resolve: {
      theme: SetThemeResolverService,
    },
  },
  {
    path: "events",
    loadChildren: () =>
      import("./events/separate-events.module").then(
        (module) => module.SeparateEventsModule
      ),
  },
  // {
  //   path: "contact-us",
  //   loadChildren: () =>
  //     import("./contact-us/contact-us.module").then(
  //       (module) => module.ContactUsModule
  //     ),
  // },
  {
    path: "teams",
    loadChildren: () =>
      import("./stemexe-news-tab/stemexe-news-tab.module").then(
        (module) => module.StemexeNewsTabModule
      ),
    canActivate: [GroupSelectedGuard],
  },
  {
    path: "privacy-policy",
    loadChildren: () =>
      import("./privacy-policy/privacy-policy.module").then(
        (m) => m.PrivacyPolicyModule
      ),
  },
  {
    path: "teams-support",
    loadChildren: () =>
      import("./teams-support/teams-support.module").then(
        (m) => m.TeamsSupportModule
      ),
  },
  { // UPGRADE-17
    path: "eula",
    loadChildren: () => import("./eula/eula.module").then((m) => m.EulaModule),
  },
  {
    path: "terms-of-use",
    loadChildren: () =>
      import("./terms-of-use/terms-of-use.module").then(
        (m) => m.TermsOfUseModule
      ),
  },
  {
    path: "anon",
    loadChildren: () =>
      import("./anonymous/anonymous.module").then((m) => m.AnonymousModule),
  },
  {
    path: "home",
    // loadChildren: () =>
    // import("./home-page/home-page.module").then(
    // (module) => module.HomePageModule
    // ),
    // canActivate: [ExceedersGuard],
    // resolve: {
    // tabs: TabsResolver
    // }
    redirectTo: "/pages/home",
    pathMatch: "full"
  },
  {
    path: "",
    redirectTo: "pages/home",
      // environment.build == ENV_BUILD.EXCEEDERS ? "home" : "pages/home",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo:
      environment.build == ENV_BUILD.EXCEEDERS ? "404" : "pages/404",
  },
];

//if (environment.enableGroupsSelection) {
//  routes.forEach(route => {
//    if (["pages", "news", "teams"].includes(route.path)) {
//      route.canLoad = [AuthGuard];
//      route.canActivate = [AuthGuard, GroupSelectedGuard];
//    }
//    if (route.path === "groups") {
//      route.canLoad = [AuthGuard];
//      route.canActivate = [AuthGuard];
//    }
//  });
//}

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: "enabled",
      scrollPositionRestoration: "top",
      initialNavigation: environment.enableGroupsSelection
        ? "enabledNonBlocking"
        : "enabledBlocking",
      // relativeLinkResolution: "legacy",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
